<template>
  <transition>
    <v-dialog-old ref="dialog" id="doctorModeration" @hidden="clearHash()" :onCloseEsc="clearHash">
      <ValidationObserver ref="modCompare">
        <mod-compare v-if="loaded"
                     :disabled="$canNot('admin.moderation.doctors.update')"
                     :o="M.old" :n="M.new" :f.sync="M.final" :p="M.info"
                     :options="modOptions" :blocks="modBlocks"
        >
          <template v-slot:duplicates>
            <fieldset v-if="$can('admin.moderation.doctors.merge')">
              <legend>Похожие врачи</legend>
              <div v-if="M.duplicates.length">
                <div>
                  <table class="table duplicates-table">
                    <tr v-for="row in M.duplicates" :class="[row.url == mergeWithUrl ? 'selected' : '']"
                        @click.stop.prevent="mergeWith(row)" class="hover pointer">
                      <td width="30" align="center">
                        <i class="far fa-check" v-if="row.url == mergeWithUrl"></i></td>
                      <td>
                        <div v-for="clinic in row.clinics">{{ clinic.cityObj.name }}</div>
                      </td>
                      <td>
                        {{ row.nameFamily }} {{ row.nameFirst }} {{ row.nameFathers }}
                        <span v-if="row.deleted_at !== null">
                                                <b class="text-danger">(Удален)</b>
                                                <span v-if="row.deletionReason === null">
                                                    Причина не указана
                                                </span>
                                                <span v-else>
                                                    {{ row.deletionReason.reason }}
                                                    <span v-if="row.deletionReason.comment !==''">
                                                        <br/>
                                                        Комментарий: {{ row.deletionReason.comment }}
                                                    </span>
                                                </span>
                                            </span>
                      </td>
                      <td>
                        <div v-for="clinic in row.clinics">{{ clinic.name }}</div>
                      </td>
                      <td>{{ row.specialitiesAsText }}</td>
                    </tr>
                    <tr style="height: 36px;">
                      <td colspan="5" align="center">
                        <button class="small" @click.stop.prevent="resetMergeWith" :disabled="mergeWithUrl == null">
                          Сброс
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div v-else>Нет похожих врачей</div>

            </fieldset>
          </template>

          <template v-slot:links>
            <fieldset style="overflow:visible;width:100%">
              <legend>Места приема</legend>
              <table class="grid">
                <tbody v-for="(clinic, index) in M.clinics" class="hover">
                <tr :class="{onmoderation: clinic.moderationNeeded, del: clinic.link_deleted}">
                  <td>{{ clinic.cityObj.name }}</td>
                  <td width="20" align="center">
                    <i class="fa fa-book"
                       :class="[clinic.hasAbonSubscription && !clinic.link_deleted ? 'text-success' : 'text-danger']"
                       v-tooltip="{content: clinic.hasAbonSubscription ? 'Есть запись' : 'Нет записи'}"
                    ></i>
                  </td>
                  <td>
                    {{ clinic.name }}
                    <span class="comma brackets">
                        <span v-if="clinic.deleted_at !== null">клиника удалена</span>
                        <span v-if="!clinic.hasAbonSubscription">нет&nbsp;записи</span>
                        </span>
                  </td>

                  <td width="100">
                        <span v-if="clinic.price !== null">{{clinic.price}} руб.</span>
                  </td>
                  <td width="30" align="right">
                    <button v-if="clinic.deleted_at === null && !clinic.link_deleted" class='small redHover square' tooltip='Удалить' @click.prevent="removeLink(index)"
                            tabindex="-1">
                      <i class="far fa-trash-can"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </fieldset>
          </template>
        </mod-compare>




      </ValidationObserver>
      <footer v-can="'admin.moderation.doctors.update'">
        <div v-if="mergeWithUrl !== null">
          <v-loading-component @click="update">
            <template slot-scope="{ loadingClass }">
              <button :class="['green', loadingClass]">Присоединить и сохранить</button>
            </template>
          </v-loading-component>
          <v-loading-component @click="cancel">
            <template slot-scope="{ loadingClass }">
              <button :class="[loadingClass]">Отменить</button>
            </template>
          </v-loading-component>
        </div>
        <div v-else style="margin:0 auto;  width: 202px;">
          <v-loading-component @click="update">
            <template slot-scope="{ loadingClass }">
              <button :class="['green', loadingClass]">Сохранить</button>
            </template>
          </v-loading-component>
          <v-loading-component v-if="M.info && M.info.approved === 1" @click="cancel">
            <template slot-scope="{ loadingClass }">
              <button :class="[loadingClass]">Отменить</button>
            </template>
          </v-loading-component>
          <v-loading-component v-if="M.info && M.info.approved === 0" @click="deleteDoctor">
            <template slot-scope="{ loadingClass }">
              <button :class="[loadingClass]">Удалить</button>
            </template>
          </v-loading-component>
          <div style="display:block;">
            <label v-if="showNextCheckBox">
              <input type="checkbox" v-model="autoNext" @change="autoNextChange"><span>Открывать следующего</span>
            </label>
          </div>
        </div>
      </footer>
    </v-dialog-old>
  </transition>
</template>

<script>
import ModCompare from "@common/modCompare/ModCompare.vue"
import {modBlocks, modDefault, modOptions} from "./DoctorModerationFields";
import {DOCTOR_MOD_TYPES} from "@global/const";

export default {
  name: "DoctorModeration",
  components: {
    ModCompare
  },
  data: function () {
    return {
      M: {
        old: modDefault(),
        old_copy: modDefault(),
        new: modDefault(),
        final: modDefault(),
        info: {
          id: '',
          approved: 1,
          moderation_id: null,
          url: '',
        },
        source: {
          dataType: '',
        },
        clinics: [],
        clinics_copy: [],
        duplicates: []
      },
      mode: 'MODERATION',
      changelogEditStart: Math.floor(Date.now() / 1000),
      mergeWithUrl: null,
      info: {
        approved: 0,
        moderation_id: null,
        id: null
      },
      placesOfWorkToBeDeleted: [],
      modOptions: modOptions(),
      modBlocks: modBlocks,
      loaded: false,
      needWait: false,
      showNextCheckBox: true,
      autoNext: localStorage.getItem(window.location.pathname + '@autoNext') !== null && window.location.pathname.indexOf('moderation') !== -1
          ? localStorage.getItem(window.location.pathname + '@autoNext') === 'true' : false,
    }
  },
  mounted() {
    this.$bus.listen('quillInProgress', (needWait) => {
      this.needWait = needWait
    });
    window.addEventListener('beforeunload', this.clearHash);
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.clearHash);
  },
  methods: {
    resetMergeWith (){
      if (this.mergeWithUrl !== null) {
        this.M.old = JSON.parse(JSON.stringify( this.M.old_copy));
        this.mergeWithUrl = null;
        this.M.clinics = JSON.parse(JSON.stringify( this.M.clinics_copy));
      }
    },
    mergeWith(doctor) {
      this.resetMergeWith();
      if (doctor !== null &&
          doctor.deleted_at !== null &&
          doctor.deletionReason !== null &&
          doctor.deletionReason.blocker === true
      ) {
        return;
      }
        this.mergeWithUrl = doctor.url
        this.M.clinics = this.M.clinics.concat(JSON.parse(JSON.stringify(doctor.clinics)));
        this.M.old = JSON.parse(JSON.stringify( doctor));
        delete(this.M.old.clinics)
    },
    clearHash() {
      if (this.info.id) {
        this.axios.get('/admin/moderation/doctors/' + this.info.id + '/close');
      }

      window.location.hash = '';
    },
    removeLink(index) {
        this.placesOfWorkToBeDeleted.push(this.M.clinics[index].id)
        this.M.clinics[index].link_deleted = true;
    },
      validateEmploymentDates () {
        let isError = false;

        for (const [key, employment] of Object.entries(this.M.final.employment)) {
          if (employment.now || !employment.y1 || !employment.y2) {
              document.querySelectorAll('.employments input.year2')[key].classList.remove('attentionValidationOnSubmitError');
              continue;
          }

          let date1 = new Date(employment.y1, employment.m1 - 1, 1);
          let date2 = new Date(employment.y2, employment.m2 - 1, 1);

          if (date2 < date1) {
              document.querySelectorAll('.employments input.year2')[key].classList.add('attentionValidationOnSubmitError');
              isError = true;
          } else {
              document.querySelectorAll('.employments input.year2')[key].classList.remove('attentionValidationOnSubmitError');
          }
        }

        return isError;
      },
    update(btn) {
      if (this.validateEmploymentDates()) {
        return;
      }

      this.$refs.modCompare.validate().then(success => {
        if (!success) {
          const el = document.querySelector(".hasError:first-of-type");
          el.scrollIntoView({behavior: "smooth"});
          return;
        }
        btn.startLoadingAnimation();

        this.$nextTick(() => {
          this.$bus.fire('moderateClinics');
        });
        setTimeout(() => {
          let delay = 2;
          if (this.needWait) {
            delay = 450
          }
          setTimeout(() => {
            this.updateRequest().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
          }, delay);
        }, 40);
      });
    },
    updateRequest() {
      return this.axios.post('/admin/moderation/doctors/moderation_update/' + this.info.id,
          {
            ...this.M.final,
            oldUrl: this.oldUrl,
            moderationId: this.info.moderation_id,
            mergeWithUrl: this.mergeWithUrl,
            placesOfWorkToBeDeleted: this.placesOfWorkToBeDeleted,
            changelogDuration: Math.floor(Date.now() / 1000) - this.changelogEditStart,
            mode: this.mode
          }).then(data => {
        this.fireUpdatedEvent()
      }).catch(data => {
          this.$root.showErrorDialog({
              message: data.message
          });
      });
    },
    autoNextChange () {
      localStorage.setItem(window.location.pathname + '@autoNext', this.autoNext);
    },
    cancel(btn) {
      this.$modal(`Вы действительно хотите отменить изменения?`,
          {
            name: "Отменить изменения",
            callback: () => {
              btn.startLoadingAnimation();
              this.cancelRequest().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
            }
          },
          {
            name: "Нет"
          }
      );
    },
    deleteDoctor() {
      this.$modal(`Вы действительно хотите безвозвратно удалить врача?`,
          {
            name: "Удалить врача",
            btnClass: 'red',
            callback: () => {
              this.deleteRequest();
            }
          },
          {
            name: "Нет"
          }
      );
    },
    cancelRequest(){
      if (!this.M.info.moderation_id) {
        this.$refs.dialog.hide();
      } else {
        this.axios.post('/admin/moderation/doctors/cancel/' + this.M.info.moderation_id, {}).then(data => {
            this.fireUpdatedEvent()
        });
      }
    },
    deleteRequest(){
      this.axios.post('/admin/moderation/doctors/delete/' + this.M.info.id,{}).then(data => {
        this.fireUpdatedEvent()
      });
    },
    fireUpdatedEvent () {
      if (!this.autoNext) {
        this.$emit('updated');
      }

      this.$bus.fire('updateMenu');
      this.$refs.dialog.hide();

      if (this.autoNext) {
        this.$emit('openNext', this.M.info.id);
      }
    },
    showModal(id, showNextCheckBox = true, mode = 'MODERATION') {
      this.showNextCheckBox = showNextCheckBox;
      this.mode = mode
      this.mergeWithUrl = null;
      return this.getData(id);
    },
    getData(doctor_id) {
      let action = this.mode === 'MODERATION' ? '' : 'moderation_read_merge/';
      let requestPromise = this.axios.get('/admin/moderation/doctors/' + action + doctor_id);

      requestPromise.then(data => {
        if (data.data.error) {
          this.$modal(data.data.error, {
            name: 'ОК',
            callback: () => {
            }
          }, {}, false, 'only-text-dialog');
          return;
        }
        Object.assign(this.M, data.data);
        this.info = JSON.parse(JSON.stringify(data.data.info));
        this.M.final = JSON.parse(JSON.stringify(data.data.new));
        this.M.old_copy = JSON.parse(JSON.stringify(data.data.old));
        this.M.clinics_copy = JSON.parse(JSON.stringify(data.data.clinics));

        this.loaded = true;
        this.placesOfWorkToBeDeleted = [];
        this.$refs.dialog.show();

        setTimeout(() => {
          document.querySelector('.addEducation').click();
          document.querySelector('.addCertificate').click();
          document.querySelector('.addEmployment').click();
          document.querySelector('.addAssociation').click();

          setTimeout(() => {
            document.querySelectorAll('.educationSpeciality')
                .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
            document.querySelectorAll('.certificateName')
                .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
            document.querySelectorAll('.employmentName')
                .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
            document.querySelectorAll('.employmentPosition')
                .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
            document.querySelectorAll('.associationName')
                .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
          }, 10);
        }, 100)
      });

      return requestPromise;
    }
  },
  computed: {
    oldUrl () {
      if (this.M.old.url === this.M.final.url){
        return this.M.new.url;
      }else{
        return this.M.old.url;
      }
    },
  },
}
</script>

<style lang="scss">
#doctorModeration {
  max-width: 1500px;
}
#doctorModeration .onmoderation{
  background-color: rgba(255, 255, 0, 0.22) !important;
  border-right: 1px solid rgba(229, 230, 0, 0.22) !important;
}
#doctorModeration .duplicates-table {
    td {
        border: 1px #D2D2D2 solid;
        padding: 0 5px;
    }
}
#doctorModeration .cropper-crop-box::after {
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    background:
        linear-gradient(to bottom, transparent 30%, #000 30%, #000 calc(30% + 1px), transparent calc(30% + 1px)),
        linear-gradient(to right, transparent calc(50% - 1px), #000 calc(50% - 1px), #000 50%, transparent 50%);
    z-index: 5;
    pointer-events: none;
}
</style>
